import React, { useEffect, useContext, useState, useCallback } from 'react';
import FormDefault from '~/components/FormDefault';
import { Container, FormProducao } from './styles';
import { GridRowParams } from '@material-ui/data-grid';
import { loadingContext } from '~/context/loading';
import { toast } from 'react-toastify';
import Search from '~/components/Search';
import Separator from '~/components/Separator';
import { Col, Row } from 'react-bootstrap';
import { useCadastroProducao } from './hook/useCadastroProducao';
import { formatCurrencyAsText, transformAsCurrency } from '~/utils/functions';
import DefaultLoader from '~/components/DefaultLoader';
import { HeaderForm } from './components/Header';
import { InputsProduto } from './components/Body';
import { Footer } from './components/Footer';
import { useHandleFocus } from '~/pages/CadastroDePoducao/hook/useHandleFocus';
import { producaoServices } from './services';
import { nanoid } from 'nanoid';
import { insertOrUpdate } from '~/utils/masterDetail';
import { calculaSubTotal } from './functions/calcSubTotal';
import { producaoSubmit } from './types';
import { parseDecimal } from './functions/formatToDecimal';
import { calcUnitario } from './functions/calcUnit';

const masterDetailDefault = [
  {
    obj_name: 'produtos',
    pk_fields: ['cod_seq_produto_producao'],
    itens: {
      insert: [],
      update: [],
      delete: [],
    },
  },
];

const CadastroProducaoContent: React.FC = () => {
  const {
    setFormData,
    isUpdate,
    setIsUpdate,
    formData,
    formProducao,
    produtosRows,
    containerRef,
    masterDetail,
    setMasterDetail,
    setProdutosRows,
    setUpdateItem,
    setProdutoIdUpdate,
    setProdutoAtual,
    setQtdTotReceita,
    setCustoSemImposto,
    setValCustoReceita,
    setQtdTotProducao,
    setQtdRendeKg,
    setValCustoProducao,
    setValCustoFinal,
  } = useCadastroProducao();
  const { setValue, getValues, handleSubmit, reset } = formProducao;
  const { setLoading, loading } = useContext(loadingContext);
  const [showSearch, setShowSearch] = useState(true);
  const { handleInputFocus } = useHandleFocus();

  useEffect(() => {
    if (showSearch) return;
    const { qtd_rendimento, per_despesa_producao } = getValues();
    if (qtd_rendimento === '0,00') {
      return handleInputFocus('qtd_rendimento');
    }
    if (qtd_rendimento !== '0,000' && per_despesa_producao === '0,00') {
      return handleInputFocus('per_despesa_producao');
    }
    if (qtd_rendimento && per_despesa_producao) {
      return handleInputFocus('busca_produto');
    }
  }, [handleInputFocus, showSearch, getValues]);

  const onSave = handleSubmit(async (dataForm: any) => {
    if (produtosRows.length <= 0) {
      setTimeout(() => {
        handleInputFocus('busca_produto');
      }, 10);
      return toast.warn('Ao menos um produto deve ser informado');
    }
    if (transformAsCurrency(dataForm.qtd_rendimento) < 0.001) {
      handleInputFocus('qtd_rendimento');
      return toast.warn('Redimento deve ser informado.');
    }

    const { qtd_rendimento, per_despesa_producao } = getValues();
    const producaoData: producaoSubmit = {
      cod_loja: Number(formData.cod_loja),
      cod_produto: formData.cod_produto,
      qtd_rendimento: transformAsCurrency(qtd_rendimento),
      per_despesa_producao: transformAsCurrency(per_despesa_producao),
      masterDetail,
    };

    const { success, message } = await producaoServices.createProducao(
      producaoData,
    );

    if (success) {
      toast.success(message);
      setShowSearch(true);
      resetFormData();
      setUpdateItem(false);
    }

    setLoading(false);
    resetFormData();
    handleInputFocus('qtd_rendimento');
  });

  const getProdutcs = async (
    cod_loja: number,
    cod_produto: string | number,
    qtdRendimento: number,
  ) => {
    const { success, data } = await producaoServices.getProducao(
      cod_loja,
      cod_produto,
    );
    if (!success) return;
    if (data.length <= 0) {
      setProdutosRows([]);
      return setLoading(false);
    }
    const { per_despesa_producao } = getValues();
    const producaoRows = Array.from(data);
    const filtredRows = producaoRows.filter((item: any) => {
      return !produtosRows.some(
        (row: any) =>
          row.cod_loja === Number(cod_loja) &&
          row.cod_produto === item.cod_produto_producao,
      );
    });
    const totalQtdReceita = filtredRows.reduce((total: number, item: any) => {
      return total + transformAsCurrency(item.qtd_receita);
    }, 0);

    const options = filtredRows.map((item: any) => {
      const uuid = nanoid();

      const resultCalcUnitario = calcUnitario({
        qtdReceita: parseDecimal(item.qtd_receita),
        totQtdReceita: totalQtdReceita,
        qtdRendimento,
        produtoAtual: item,
      });
      return {
        uuid,
        id: uuid,
        cod_loja: Number(cod_loja),
        cod_produto: item.cod_produto_producao,
        des_produto: item.des_produto,
        des_unidade: item.des_unidade_venda,
        cod_associado: item.cod_associado,
        val_custo_rep: item.val_custo_rep,
        val_custo_sem_icms: item.val_custo_sem_icms,
        qtd_rendimento: resultCalcUnitario.qtdRendeKg,
        qtd_receita: item.qtd_receita,
        qtd_producao: resultCalcUnitario.qtdProducao,
        flg_ipv: item.flg_ipv,
        custoSemImpostoFinal: resultCalcUnitario.custoSemImpostoFinal,
        custoFinal: resultCalcUnitario.custoFinal,
      };
    }) as any;

    const promises = options.map((row: any) =>
      insertOrUpdate('produtos', row, masterDetail, setMasterDetail),
    );
    const results = await Promise.all(promises);
    const rowsDetail = results.flat();
    const uniqueRows = Array.from(
      new Map(
        rowsDetail.map((item) => [
          `${item.cod_loja}_${item.cod_produto}`,
          item,
        ]),
      ).values(),
    );
    const resultadoCalcSubTotal = calculaSubTotal({
      itens: uniqueRows,
      perDespesaProducao: transformAsCurrency(per_despesa_producao),
    });

    setQtdRendeKg(resultadoCalcSubTotal.rendeKg);
    setQtdTotProducao(resultadoCalcSubTotal.totQtdProducao);
    setQtdTotReceita(resultadoCalcSubTotal.totQtdReceita);
    setCustoSemImposto(resultadoCalcSubTotal.custoSemImp);
    setValCustoFinal(resultadoCalcSubTotal.custoFinalProducao);
    setValCustoReceita(resultadoCalcSubTotal.custoReceita);
    setValCustoProducao(resultadoCalcSubTotal.custoProducao);
    setProdutosRows(uniqueRows);
    setLoading(false);

    return resultadoCalcSubTotal;
  };

  const onRowClick = async (param: GridRowParams) => {
    const { row } = param;
    const {
      per_despesa_producao,
      qtd_rendimento,
      cod_loja,
      cod_produto,
      des_produto,
    } = row;

    getProdutcs(cod_loja, cod_produto, qtd_rendimento);

    setFormData({
      cod_loja,
      cod_produto,
      des_produto,
    });
    setValue(
      'per_despesa_producao',
      formatCurrencyAsText(per_despesa_producao, 2, 2),
    );
    setValue('qtd_rendimento', formatCurrencyAsText(qtd_rendimento, 3, 3));

    setIsUpdate(true);
    setLoading(false);
    setShowSearch(false);
  };

  const resetFormData = useCallback(() => {
    setMasterDetail(JSON.parse(JSON.stringify(masterDetailDefault)));
    setProdutosRows([]);
    setProdutoIdUpdate(undefined);
    setProdutoAtual(null);
    setIsUpdate(false);
    setUpdateItem(false);
    setQtdTotReceita(0);
    setCustoSemImposto(0);
    setValCustoReceita(0);
    setQtdTotProducao(0);
    setQtdRendeKg(0);
    setValCustoProducao(0);
    setValCustoFinal(0);
    reset();
  }, [
    setMasterDetail,
    reset,
    setProdutoIdUpdate,
    setProdutoAtual,
    setIsUpdate,
    setProdutosRows,
    setUpdateItem,
    setCustoSemImposto,
    setValCustoReceita,
    setQtdRendeKg,
    setQtdTotProducao,
    setValCustoProducao,
    setValCustoFinal,
    setQtdTotReceita,
  ]);

  if (loading) {
    return <DefaultLoader />;
  }
  return (
    <Container>
      {showSearch && (
        <Search
          onlyReport
          newData={() => setShowSearch(false)}
          onRowClick={onRowClick}
          codTela={313}
        />
      )}

      {!showSearch && (
        <FormDefault
          codTela={313}
          title="Cadastro de Produção"
          codigoRegistro={[
            {
              value: formData.cod_produto,
              des_campo: 'Código',
            },
          ]}
          onSave={async () => {
            await onSave();
          }}
          isUpdate={isUpdate}
          onCancel={() => null}
          onNew={() => null}
          onDelete={() => null}
          isDelete={false}
          isNew={false}
          onClearFields={() => null}
          onReturnSearch={() => {
            resetFormData();
            setShowSearch(true);
          }}
        >
          <FormProducao ref={containerRef}>
            <Row>
              <Col sm={12} md={12}>
                <HeaderForm />
              </Col>
            </Row>
            <Row>
              <Col md={12} sm={12}>
                <Separator labelText="Produtos da Produção" sidePadding="0 0" />
              </Col>
            </Row>
            <Row>
              <Col md={12} sm={12}>
                <InputsProduto />
              </Col>
            </Row>
            <Row>
              <Col md={12} sm={12}>
                <Footer />
              </Col>
            </Row>
          </FormProducao>
        </FormDefault>
      )}
    </Container>
  );
};

export default CadastroProducaoContent;
